import React from 'react';
import cl from './Footer.module.css';
import { NavLink } from 'react-router-dom';

const Footer = (props) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={cl.app_footer}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          padding: '20px',
          borderBottom: '1px solid var(--primary)',
        }}
      >
        <form action="/subscribe" method="post">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Su correo electrónico"
            required
          ></input>

          <button type="button" style={{}}>
            Suscribirse
          </button>
        </form>
      </div>
      <div className={cl.app_footer_main}>
        <div
          className={cl.app_footer_links}
          style={{
            marginBottom: '20px',
          }}
        >
          <p style={{ fontSize: '20px', marginBottom: '10px' }}>Tienda</p>
          <NavLink className={cl.footer_link} to="">
            Hogar
          </NavLink>
          <NavLink className={cl.footer_link} to="/about">
            Información
          </NavLink>
          <NavLink className={cl.footer_link} to="/products">
            Productos
          </NavLink>
          <NavLink className={cl.footer_link} to="/contacts">
            Contactos
          </NavLink>
        </div>
        <div
          className={cl.app_footer_links}
          style={{
            marginBottom: '20px',
          }}
        >
          <p style={{ fontSize: '20px', marginBottom: '10px' }}>
            Política de la Tienda
          </p>
          <NavLink className={cl.footer_link} to="/policy">
            Política de Privacidad
          </NavLink>
          <NavLink className={cl.footer_link} to="/terms">
            Términos de Servicio
          </NavLink>
          <NavLink className={cl.footer_link} to="/refund-policy">
            Política de Reembolso
          </NavLink>
          <NavLink className={cl.footer_link} to="/shipping-policy">
            Política de Envío
          </NavLink>
          <NavLink className={cl.footer_link} to="/cookies-policy ">
            Política de Cookies
          </NavLink>
        </div>
        <div>
          <p style={{ fontSize: '20px', marginBottom: '10px' }}>
            Horario de Apertura
          </p>
          <p style={{ marginBottom: '10px' }}>Lunes - Viernes: 7:00 - 22:00</p>
          <p style={{ marginBottom: '10px' }}>Sábado: 8:00 - 22:00</p>
          <p style={{ marginBottom: '10px' }}>Domingo: 8:00 - 23:00</p>
        </div>
      </div>
      <div className={cl.app_footer_bottom_line}>
        <p>
          &#169; {currentYear} by {props.shopName}. All rights reserved
        </p>
        <div className={cl.app_footer_info}>
          <img
            src="https://cdn.icon-icons.com/icons2/1186/PNG/512/1490135017-visa_82256.png"
            alt="Visa"
          />
          <img
            src="https://www.iconarchive.com/download/i76278/designbolts/credit-card-payment/Master-Card.ico"
            alt="Master Card"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
